import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["menu", "closeArea", "container", "button"]

  connect() {
    this.boundOutside = this.handleOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutside)
  }

  toggle() {
    this.isOpen() ? this.close() : this.open()
  }

  open(options = {}) {
    if (this.isOpen()) return
    this.menuTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.boundOutside)
    options.focus === "last" ? this.focusLastItem() : this.focusFirstItem()
  }

  openFromKey(event) {
    event.preventDefault()
    this.open()
  }

  openLastFromKey(event) {
    event.preventDefault()
    this.open({ focus: "last" })
  }

  close(options = {}) {
    if (!this.isOpen()) return
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundOutside)
    if (options.restoreFocus !== false) this.buttonTarget.focus()
  }

  isOpen() {
    return !this.menuTarget.classList.contains("hidden")
  }

  handleOutside(event) {
    if (!this.isOpen()) return
    const clickedInsideMenu = this.containerTarget.contains(event.target) && event.target !== this.closeAreaTarget
    const clickedInsideButton = this.buttonTarget.contains(event.target)
    if (!clickedInsideMenu && !clickedInsideButton) this.close({ restoreFocus: false })
  }

  focusFirstItem() {
    this.items[0]?.focus()
  }

  focusLastItem() {
    this.items.at(-1)?.focus()
  }

  navigate(event) {
    if (event.key === "Tab") {
      this.close()
      return
    }
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
      return
    }
    if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) return

    event.preventDefault()
    const items = this.items
    if (!items.length) return
    const currentIndex = items.indexOf(document.activeElement)
    let nextIndex
    if (event.key === "Home") nextIndex = 0
    if (event.key === "End") nextIndex = items.length - 1
    if (event.key === "ArrowDown") nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % items.length
    if (event.key === "ArrowUp") nextIndex = currentIndex < 0 ? items.length - 1 : (currentIndex - 1 + items.length) % items.length
    items[nextIndex].focus()
  }

  activate(event) {
    this.close({ restoreFocus: event.currentTarget.contains(document.activeElement) })
  }

  activateFromKey(event) {
    event.preventDefault()
    event.currentTarget.click()
  }

  get items() {
    return Array.from(this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled]):not([aria-disabled="true"])'))
  }
}
